import { render, staticRenderFns } from "./ChangelogLatestModal.vue?vue&type=template&id=a8a8c73c&scoped=true&"
import script from "./ChangelogLatestModal.vue?vue&type=script&lang=js&"
export * from "./ChangelogLatestModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogLatestModal.vue?vue&type=style&index=0&id=a8a8c73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a8c73c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a8c73c')) {
      api.createRecord('a8a8c73c', component.options)
    } else {
      api.reload('a8a8c73c', component.options)
    }
    module.hot.accept("./ChangelogLatestModal.vue?vue&type=template&id=a8a8c73c&scoped=true&", function () {
      api.rerender('a8a8c73c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangelogLatestModal.vue"
export default component.exports